var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.63333C1 2.8866 1 2.51323 1.14532 2.22801C1.27316 1.97713 1.47713 1.77316 1.72801 1.64532C2.01323 1.5 2.3866 1.5 3.13333 1.5H22.8667C23.6135 1.5 23.9868 1.5 24.272 1.64532C24.5229 1.77316 24.7268 1.97713 24.8547 2.22801C25 2.51323 25 2.8866 25 3.63333V5.94968C25 6.2758 25 6.43885 24.9632 6.59231C24.9305 6.72836 24.8767 6.85841 24.8035 6.97771C24.7211 7.11227 24.6057 7.22757 24.3752 7.45817L16.2915 15.5419C16.0609 15.7724 15.9456 15.8877 15.8632 16.0223C15.79 16.1416 15.7361 16.2716 15.7035 16.4077C15.6667 16.5612 15.6667 16.7243 15.6667 17.0503V20.1667L10.3333 25.5V17.0503C10.3333 16.7243 10.3333 16.5612 10.2965 16.4077C10.2638 16.2716 10.21 16.1416 10.1369 16.0223C10.0544 15.8877 9.93909 15.7724 9.70849 15.5419L1.62484 7.45817C1.39424 7.22757 1.27893 7.11227 1.19648 6.97771C1.12337 6.85841 1.06951 6.72836 1.03684 6.59231C1 6.43885 1 6.2758 1 5.94968V3.63333Z",
    stroke: "#00B6CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filter icon.f42f0900d42557b2b44e4731198465c1.svg";
export { ForwardRef as ReactComponent };